var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 16C13.0003 17.6569 11.6572 19 10.0003 19C8.34345 19 7.00031 17.6569 7.00031 16M16.0003 6.6C16.0003 5.11479 15.3682 3.69041 14.2429 2.6402C13.1177 1.59 11.5916 1 10.0003 1C8.40901 1 6.88288 1.59 5.75766 2.6402C4.63245 3.69041 4.00031 5.11479 4.00031 6.6C4.00031 9.28622 3.32411 11.1835 2.52776 12.4866C1.75646 13.7486 1.37082 14.3797 1.38515 14.5436C1.40126 14.7277 1.4376 14.7925 1.58633 14.9023C1.71872 15 2.34793 15 3.60636 15H16.3943C17.6527 15 18.2819 15 18.4143 14.9023C18.563 14.7925 18.5994 14.7277 18.6155 14.5436C18.6298 14.3797 18.2441 13.7486 17.4729 12.4866C16.6765 11.1835 16.0003 9.28622 16.0003 6.6Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2b94100a52c4e617cee90a79a22331b6.svg";
export { ForwardRef as ReactComponent };